import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Box, Dialog, Typography } from "@mui/material";
import { palette } from "../../../../../../theme/palette";
import { PrimaryButon } from "../../../../../components/common/button/PrimaryButon";
// import { PrimaryButon } from "../../../../../components/common/button/PrimaryButon";
const theme = palette("light");
export const AceptDialog = ({ open, handleClose }) => {
    return (_jsx(Dialog, { open: open, onClose: handleClose, maxWidth: false, BackdropProps: {
            sx: {
                backdropFilter: "blur(3px)",
                backgroundColor: "rgba(74, 74, 74, 0.25)",
            },
        }, children: _jsxs(Box, { width: { xs: 390, sm: 600, md: 717 }, sx: {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                height: "295px",
                px: 2,
            }, children: [_jsx(Typography, { variant: "h3", color: "initial", mt: 2, children: "Account has been accepted" }), _jsx(Typography, { variant: "subtitle1", color: theme.black.dark, children: "The user can now log in to the dashboard." }), _jsx(Box, { width: { xs: "100%", sm: "386px" }, mt: 3, children: _jsx(PrimaryButon, { onClick: handleClose, children: "Close" }) })] }) }));
};
